import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ShopByCategory } from './components/ShopByCategory';
import { Bestsellers } from './components/Bestsellers';
import { EditorialSplit } from './components/EditorialSplit';
import { Lookbook } from './components/Lookbook';
import { BrandValues } from './components/BrandValues';
import { Reviews } from './components/Reviews';
import { Newsletter } from './components/Newsletter';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <Header data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <ShopByCategory data-id="element-5" />
        <Bestsellers data-id="element-6" />
        <EditorialSplit data-id="element-7" />
        <Lookbook data-id="element-8" />
        <BrandValues data-id="element-9" />
        <Reviews data-id="element-10" />
        <Newsletter data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}